function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("g", {
  fill: "#004152",
  fillRule: "evenodd"
}, React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M61.792 16.303c1.05 0 1.902-.845 1.902-1.888a1.895 1.895 0 0 0-1.902-1.887c-1.05 0-1.903.845-1.903 1.887 0 1.043.852 1.888 1.903 1.888zm0 .64a2.538 2.538 0 0 1-2.55-2.528 2.538 2.538 0 0 1 2.55-2.528 2.538 2.538 0 0 1 2.548 2.528 2.538 2.538 0 0 1-2.548 2.528zM43.951 16.303c1.05 0 1.903-.845 1.903-1.888a1.895 1.895 0 0 0-1.903-1.887c-1.05 0-1.902.845-1.902 1.887 0 1.043.852 1.888 1.902 1.888zm0 .64a2.538 2.538 0 0 1-2.548-2.528 2.538 2.538 0 0 1 2.548-2.528 2.538 2.538 0 0 1 2.549 2.528 2.538 2.538 0 0 1-2.549 2.528z"
}), React.createElement("path", {
  d: "M59.254 5.202v6.138h.402V5.202h4.684l2.549 3.416v5.123h-1.7s-.849-2.562-3.397-2.562c-1.7 0-2.55.854-3.399 2.562H47.35s-.85-2.562-3.399-2.562c-2.548 0-3.398 2.562-3.398 2.562h-3.398v-1.708l.85-.854V2.641h12.743L53.296.933h10.195s.85.854.85 1.708v1.707h-5.098v.854h.011zm-14.453 0v4.27h2.549v-4.27H44.8zm8.495 0V6.91h3.398V5.202h-3.398zm8.496.854v2.562h3.398l-1.7-2.562h-1.698z"
})), React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M8.84 13.978c0-.809.803-4.046-3.215-4.046s-2.41 4.046-3.214 4.046H0V9.932C0 8.314 2.41 1.84 3.214 1.84h19.287c1.607 1.619 6.429 7.283 7.233 8.092v4.046h-1.608c0-.809 0-4.046-3.214-4.046s-3.214 2.428-3.214 4.046H8.84zm11.25-10.52v3.237h4.822L21.698 3.46H20.09z"
}), React.createElement("path", {
  d: "M5.783 16.015a2.68 2.68 0 0 1-2.671-2.687 2.68 2.68 0 0 1 2.67-2.688 2.68 2.68 0 0 1 2.672 2.688 2.68 2.68 0 0 1-2.671 2.687zm0-.691c1.093 0 1.98-.893 1.98-1.996a1.988 1.988 0 0 0-1.98-1.996c-1.093 0-1.98.893-1.98 1.996s.887 1.996 1.98 1.996zM25.07 15.943a2.606 2.606 0 0 1-2.597-2.614 2.606 2.606 0 0 1 2.598-2.613 2.606 2.606 0 0 1 2.598 2.613 2.606 2.606 0 0 1-2.598 2.614zm0-.692c1.053 0 1.907-.86 1.907-1.922a1.914 1.914 0 0 0-1.906-1.922c-1.052 0-1.906.86-1.906 1.922 0 1.062.854 1.922 1.906 1.922z"
})), React.createElement("text", {
  fontFamily: "GTWalsheimProRegular, GT Walsheim Pro",
  fontSize: 12
}, React.createElement("tspan", {
  x: 31.034,
  y: 13.128
}, "/")));

var SvgVehicleVanHigh = function SvgVehicleVanHigh(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 67,
    height: 17,
    viewBox: "0 0 67 17",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVehicleVanHigh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vehicle-van-high.b76160e9.svg";
export { ForwardRef as ReactComponent };